import { Link } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";

const AdminMainContent = () => {
  const { user } = useAuthContext();
  
  return (
    <div className="main-content">
      <div className="card">
        <Link to='/user-management'>
          <h2>Welcome, Admin {user.name}!</h2>
          <p>Manage users, view reports, and configure settings from this dashboard.</p>
        </Link>
      </div>
    
      <div className="card">
        <Link to='/documents'>
          <h2>View uploaded documents</h2>
          <p>See the latest updates and perfom new changes</p>
        </Link>
      </div>

      <div className="card">
        <Link to='/learner-track'>
          <h2>Recent Activities written by learners</h2>
          <p>See and track learners progress from the given quiz.</p>    
        </Link>
      </div>
    </div>
  );
};

export default AdminMainContent;
